import { useState, useEffect } from "react";

export const useOnScreen = ({
  ref,
  scrollDirection = undefined,
  bounds = false,
  root = null,
  rootMargin = "0px",
  threshold = [0],
}) => {
  const [isIntersecting, setIntersecting] = useState(!Array.isArray(ref) || []);

  const observerCallback = ([entry]) => {
    if (!Array.isArray(ref)) setIntersecting(entry.isIntersecting);
    else {
      setTimeout(() => {
        setIntersecting((previous) => {
          if (entry.isIntersecting) {
            switch (scrollDirection) {
              case "down":
                return !previous.includes(entry.target.id)
                  ? [entry.target.id, ...previous]
                  : previous;
              case "up":
                return !previous.includes(entry.target.id)
                  ? [...previous, entry.target.id]
                  : previous;
              default:
                return previous;
            }
          } else
            return previous.filter((element) => element !== entry.target.id);
        });
      }, 0);
    }
  };

  useEffect(() => {
    if (bounds) setIntersecting([]);
  }, [bounds]);

  useEffect(() => {
    const observer = new IntersectionObserver(observerCallback, {
      root: document.querySelector(root),
      rootMargin,
      threshold,
    });

    if (!Array.isArray(ref)) {
      if (ref.current) {
        observer.observe(ref.current);
      }
    } else {
      for (const element of ref) {
        if (element.current) {
          observer.observe(element.current);
        }
      }
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return isIntersecting;
};
